import React, { useState } from "react";
import Modal from "../../../common/Modal/Modal";
import "../../../common/Modal/Modal.css";

const templates = [{ name: "Template 1", created: "2025-07-01" }];
const objects = [{ name: "Object 1", created: "2025-07-01" }];

export default function TemplateObjectConfiguration() {
  const { ObjectConfig, TemplateConfig } = JSON.parse(
    sessionStorage.getItem("rolesAndPermission") || "{}"
  );
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [showObjectModal, setShowObjectModal] = useState(false);

  // Random fields for now
  const [templateForm, setTemplateForm] = useState({
    name: "",
    description: "",
    source: "",
    target: "",
  });
  const [objectForm, setObjectForm] = useState({
    name: "",
    description: "",
    orgName: "",
    templateName: ""
  });

  return (
    <div className="rounded-2xl bg-white p-6 shadow-md mt-6">
      <h2 className="text-3xl font-bold mb-6">
        Template & Object Configuration
      </h2>
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <span className="font-semibold text-lg">Template Configuration</span>
          {TemplateConfig.canAdd && (
            <button className="bg-blue-700 text-white px-4 py-1 rounded-lg flex items-center gap-2 hover:bg-blue-800" onClick={() => setShowTemplateModal(true)}>
              <span className="text-xl font-bold">+</span> Add Template
            </button>
          )}
        </div>
        <table className="min-w-full bg-white rounded-lg mb-4 table-fixed">
          <thead>
            <tr className="border-b">
              <th className="py-2 px-4 text-left font-semibold w-1/3">
                Template Name
              </th>
              <th className="py-2 px-4 text-left font-semibold w-1/3">
                Created Date
              </th>
              {(TemplateConfig.canUpdate || TemplateConfig.canDelete) && (
                <th className="py-2 px-4 text-left font-semibold w-1/3">Actions</th>
              )}
            </tr>
          </thead>
          <tbody>
            {templates.map((tpl, idx) => (
              <tr key={idx} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{tpl.name}</td>
                <td className="py-2 px-4">{tpl.created}</td>
                {(TemplateConfig.canUpdate || TemplateConfig.canDelete) && (
                  <td className="py-2 px-4 flex gap-2">
                    {TemplateConfig.canUpdate && (
                      <span className="cursor-pointer" title="Edit">
                        ✏️
                      </span>
                    )}
                    {TemplateConfig.canDelete && (
                      <span className="cursor-pointer" title="Delete">
                        🗑️
                      </span>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div>
        <div className="flex justify-between items-center mb-2">
          <span className="font-semibold text-lg">Objects Configuration</span>
          {ObjectConfig.canAdd && (
            <button className="bg-blue-700 text-white px-4 py-1 rounded-lg flex items-center gap-2 hover:bg-blue-800" onClick={() => setShowObjectModal(true)}>
              <span className="text-xl font-bold">+</span> Add Object
            </button>
          )}
        </div>
        <table className="min-w-full bg-white rounded-lg table-fixed">
          <thead>
            <tr className="border-b">
              <th className="py-2 px-4 text-left font-semibold w-1/3">Object Name</th>
              <th className="py-2 px-4 text-left font-semibold w-1/3">
                Created Date
              </th>
              {(ObjectConfig.canUpdate || ObjectConfig.canDelete) && (
                <th className="py-2 px-4 text-left font-semibold w-1/3">Actions</th>
              )}
            </tr>
          </thead>
          <tbody>
            {objects.map((obj, idx) => (
              <tr key={idx} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{obj.name}</td>
                <td className="py-2 px-4">{obj.created}</td>
                {(ObjectConfig.canUpdate || ObjectConfig.canDelete) && (
                  <td className="py-2 px-4 flex gap-2">
                    {ObjectConfig.canUpdate && (
                      <span className="cursor-pointer" title="Edit">
                        ✏️
                      </span>
                    )}
                    {ObjectConfig.canDelete && (
                      <span className="cursor-pointer" title="Delete">
                        🗑️
                      </span>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add Template Modal */}
      <Modal show={showTemplateModal} title="Add Template" setShowModal={setShowTemplateModal}>
        <form className="modal-body" onSubmit={e => { e.preventDefault(); setShowTemplateModal(false); }}>
          <div className="modal-field">
            <label>Template Name</label>
            <input type="text" value={templateForm.name} onChange={e => setTemplateForm(f => ({ ...f, name: e.target.value }))} />
          </div>
          <div className="modal-field">
            <label>Template Description</label>
            <input type="text" value={templateForm.description} onChange={e => setTemplateForm(f => ({ ...f, description: e.target.value }))} />
          </div>
          <div className="modal-field">
            <label>Add source</label>
            <input type="text" value={templateForm.source} onChange={e => setTemplateForm(f => ({ ...f, source: e.target.value }))} />
          </div>
          <div className="modal-field">
            <label>Add target</label>
            <input type="text" value={templateForm.target} onChange={e => setTemplateForm(f => ({ ...f, target: e.target.value }))} />
          </div>
          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={() => setShowTemplateModal(false)}>Cancel</button>
            <button type="submit" className="submit-btn">Save</button>
          </div>
        </form>
      </Modal>

      {/* Add Object Modal */}
      <Modal show={showObjectModal} title="Add Object" setShowModal={setShowObjectModal}>
        <form className="modal-body" onSubmit={e => { e.preventDefault(); setShowObjectModal(false); }}>
          <div className="modal-field">
            <label>Object Name</label>
            <input type="text" value={objectForm.name} onChange={e => setObjectForm(f => ({ ...f, name: e.target.value }))} />
          </div>
          <div className="modal-field">
            <label>Object Description</label>
            <input type="text" value={objectForm.description} onChange={e => setObjectForm(f => ({ ...f, description: e.target.value }))} />
          </div>
          <div className="modal-field">
            <label>Organization name</label>
            <input type="text" value={objectForm.orgName} onChange={e => setObjectForm(f => ({ ...f, orgName: e.target.value }))} />
          </div>
          <div className="modal-field">
            <label>Template name</label>
            <input type="text" value={objectForm.templateName} onChange={e => setObjectForm(f => ({ ...f, templateName: e.target.value }))} />
          </div>
          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={() => setShowObjectModal(false)}>Cancel</button>
            <button type="submit" className="submit-btn">Save</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
